









import { Component, Prop, Vue, Provide, Watch } from 'vue-property-decorator'
import TenantBreadcrumbBar from '@/components/TenantBreadcrumbBar/index.vue'
@Component({
    components: {
        TenantBreadcrumbBar
    }
})
export default class Breadcrumb extends Vue {
    @Prop() private msg!: string
    @Provide() private breadList: string[] = []

    get items() {
        return this.breadList.map((name, index) => ({
            key: name,
            label: this.$t(name === '/' ? 'nav.bread.home' : name),
            current: index === this.breadList.length - 1,
            clickable: name === '/',
            name
        }))
    }

    private created() {
        this.getBreadList()
    }

    @Watch('$route')
    private getBreadList() {
        this.breadList = []
        for (const routeInfo of this.$route.matched) {
            if (routeInfo.path && routeInfo.meta.title) {
                this.breadList.push(routeInfo.meta.title)
            }
        }
    }

    homeLink(): void {
        this.$router.push({ path: '/' })
    }

    back(): void {
        window.history.go(-1)
    }

    select(item: { name: string }): void {
        if (item.name === '/') {
            this.homeLink()
        }
    }
}
